import { TagIcon } from 'lucide-react'

type AdpDiscountBannerProps = {
  discountPercentage: number;
  deadlineDate: string;
  discountEndDate: string;
  message?: string;
}

function formatDate (isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  })
}

function formatMonthYear (isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-US', {
    month: 'long',
  })
}

export function AdpDiscountBanner ({
  discountPercentage,
  deadlineDate,
  discountEndDate,
  message,
}: AdpDiscountBannerProps) {
  const formattedDeadline = formatDate(deadlineDate)
  const formattedEndDate = formatMonthYear(discountEndDate)
  const defaultMessage = `${discountPercentage}% off monthly platform fee through ${formattedEndDate} when you invite your team by ${formattedDeadline}!`

  return (
    <div className='bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center gap-3'>
      <div className='bg-green-400 rounded-full p-2 flex items-center justify-center shrink-0'>
        <TagIcon className='text-white' size={18} />
      </div>
      <p className='body-sm-bold text-green-400'>
        {message || defaultMessage}
      </p>
    </div>
  )
}
